<template>
  <div class="product-collect">
    <catalog-tree
      ref="catalogTree"
      categoryType="ProdFavoriteDir"
      @dirChanged="dirChanged"
      viewHeight="calc(100vh - 53px)"
      affixTop="32px"
      title="收藏目录"
      :defaultNode="[{DirName: '我的桌面', DirID: 0, TreeID: 'list_0'}]"
    ></catalog-tree>
    <prod-list ref="prodListRef" />
  </div>
</template>

<script>
import CatalogTree from '@/components/tree-list/catalog-tree.vue';
import ProdList from './prod-list.vue';

export default {
  components: { CatalogTree, ProdList },
  methods: {
    dirChanged(data, parents) {
      this.$refs.prodListRef.dirChanged(data.DirID || 0, parents);
    }
  }
}
</script>

<style lang="less" scoped>
.product-collect{
  display: flex;
  flex-direction: row;
  background-color: #ffffff;
  box-shadow: 0px 6px 20px 0px rgba(0, 0, 0, 0.1);
}
</style>
